var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00001C14.6666 4.31811 11.6818 1.33334 7.99992 1.33334C4.31802 1.33334 1.33325 4.31811 1.33325 8.00001C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16668C8.27333 9.16668 8.5 8.94001 8.5 8.66668V5.33334C8.5 5.06001 8.27333 4.83334 8 4.83334C7.72667 4.83334 7.5 5.06001 7.5 5.33334V8.66668C7.5 8.94001 7.72667 9.16668 8 9.16668Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61325 10.4133C8.57992 10.3333 8.53325 10.26 8.47325 10.1933C8.40659 10.1333 8.33325 10.0867 8.25325 10.0533C8.09325 9.98666 7.90659 9.98666 7.74659 10.0533C7.66659 10.0867 7.59325 10.1333 7.52659 10.1933C7.46659 10.26 7.41992 10.3333 7.38659 10.4133C7.35325 10.4933 7.33325 10.58 7.33325 10.6667C7.33325 10.7533 7.35325 10.84 7.38659 10.92C7.41992 11.0067 7.46659 11.0733 7.52659 11.14C7.59325 11.2 7.66659 11.2467 7.74659 11.28C7.82659 11.3133 7.91325 11.3333 7.99992 11.3333C8.08659 11.3333 8.17325 11.3133 8.25325 11.28C8.33325 11.2467 8.40659 11.2 8.47325 11.14C8.53325 11.0733 8.57992 11.0067 8.61325 10.92C8.64659 10.84 8.66659 10.7533 8.66659 10.6667C8.66659 10.58 8.64659 10.4933 8.61325 10.4133Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.9b5a3d432126d246cfe3d8091822af94.svg";
export { ForwardRef as ReactComponent };